import { useEffect } from 'react'

import { DataHubStore } from '@space-core/datahub/hotmartClub'

import type { Membership } from '@space-shell/common/services/membership'

import { UserInfoRole } from '@space-shell/common/services/user'
import type { AuthType } from '@space-shell/core/store'
import { useAuthStore, useMembershipStore, useUserInfoStore } from '@space-shell/core/store'

type UseInitializeStoreParams = {
  membershipInfo: Membership
  user: AuthType
}

const DEFAULT_AUTH_STATE = {
  token: '',
  userName: '',
  userSocialName: '',
  locale: '',
  baseUrl: '',
  id: '',
  ucode: '',
  expires_at: 0,
  authorities: [],
  tokenCreatedAt: 0,
  sid: ''
}

const DEFAULT_USER_STATE = {
  role: UserInfoRole.VIEWER,
  name: '',
  avatar: '',
  email: '',
  isAttendant: false,
  isMembership: false
}

export const useInitializeStore = ({ user, membershipInfo }: UseInitializeStoreParams) => {
  useEffect(() => {
    if (user) {
      useAuthStore.setState(user)

      return
    }

    useAuthStore.setState(DEFAULT_AUTH_STATE)
    useUserInfoStore.setState(DEFAULT_USER_STATE)
  }, [user])

  useEffect(() => {
    if (membershipInfo) {
      useMembershipStore.setState({
        membershipData: membershipInfo,
        membershipSlug: membershipInfo.slug
      })

      DataHubStore.initData({
        appVersion: '1.0',
        membershipSlug: membershipInfo.slug,
        isLogged: !!user?.token,
        membershipId: membershipInfo.id,
        userId: user?.id ? Number(user?.id) : 0,
        ucode: user?.ucode || 'X',
        userRole: 'CONSUMER'
      })
    }
  }, [membershipInfo, user?.id, user?.token, user?.ucode])
}
